/**
 * Shared color themes for PassType cards (ActivePassDisplay) and the color picker in
 * AdminPassTypes. The literal class names below must stay as static strings — a value built
 * from a DB string at runtime (e.g. `bg-[${hex}]`) can't be picked up by Tailwind's content
 * scanner, so each theme bundles ready-made Tailwind classes instead. tailwind.config.js's
 * content globs include src/utils so this file is still scanned.
 */
export const PASS_CARD_THEMES = {
  green: {
    label: 'Green', swatch: '#22C55E',
    bg: 'bg-green-50', border: 'border-green-500',
    title: 'text-green-800', body: 'text-green-700',
    track: 'bg-green-200', bar: 'bg-green-600',
  },
  pink: {
    label: 'Pink', swatch: '#EC4899',
    bg: 'bg-pink-50', border: 'border-pink-500',
    title: 'text-pink-800', body: 'text-pink-700',
    track: 'bg-pink-100', bar: 'bg-pink-500',
  },
  blue: {
    label: 'Blue', swatch: '#3B82F6',
    bg: 'bg-blue-50', border: 'border-blue-500',
    title: 'text-blue-800', body: 'text-blue-700',
    track: 'bg-blue-200', bar: 'bg-blue-600',
  },
  orange: {
    label: 'Orange', swatch: '#F97316',
    bg: 'bg-orange-50', border: 'border-orange-500',
    title: 'text-orange-800', body: 'text-orange-700',
    track: 'bg-orange-200', bar: 'bg-orange-600',
  },
  red: {
    label: 'Red', swatch: '#EF4444',
    bg: 'bg-red-50', border: 'border-red-500',
    title: 'text-red-800', body: 'text-red-700',
    track: 'bg-red-200', bar: 'bg-red-600',
  },
  purple: {
    label: 'Purple', swatch: '#A855F7',
    bg: 'bg-purple-50', border: 'border-purple-500',
    title: 'text-purple-800', body: 'text-purple-700',
    track: 'bg-purple-200', bar: 'bg-purple-600',
  },
  teal: {
    label: 'Teal', swatch: '#14B8A6',
    bg: 'bg-teal-50', border: 'border-teal-500',
    title: 'text-teal-800', body: 'text-teal-700',
    track: 'bg-teal-200', bar: 'bg-teal-600',
  },
  amber: {
    label: 'Amber', swatch: '#F59E0B',
    bg: 'bg-amber-50', border: 'border-amber-500',
    title: 'text-amber-800', body: 'text-amber-700',
    track: 'bg-amber-200', bar: 'bg-amber-600',
  },
  gray: {
    label: 'Gray', swatch: '#6B7280',
    bg: 'bg-gray-50', border: 'border-gray-500',
    title: 'text-gray-800', body: 'text-gray-700',
    track: 'bg-gray-200', bar: 'bg-gray-600',
  },
};

export const DEFAULT_PASS_CARD_THEME = 'green';

export function getPassCardTheme(colorKey) {
  return PASS_CARD_THEMES[colorKey] || PASS_CARD_THEMES[DEFAULT_PASS_CARD_THEME];
}
